import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'

export const fileApi = {
	getFile: async (url: string) => {
		const res = await axiosDS().get<Blob>(url, { responseType: 'blob' })
		return res.data
	},
	deleteFile: async (url: string) => {
		const res = await axiosDS().delete<SimpleResponse>(url)
		return res.data
	},
}
